import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useRest, money } from './restui';

/* Compact ROI strip — with vs without Kitxens (estimated), reused across demo pages. */
export function KxRoiStrip({ isEs, className = '' }) {
  const { data: d } = useRest('/impact?period=month');
  if (!d?.has_data || d.extra_revenue == null) return null;
  return (
    <Link to="/restaurant" data-testid="kx-roi-strip"
      className={`mb-4 flex flex-wrap items-center gap-x-3 gap-y-1 rounded-xl border border-[var(--rest-accent)]/25 bg-[var(--rest-accent-soft)] px-3.5 py-2 hover:border-[var(--rest-accent)]/60 transition-colors ${className}`}>
      <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.15em] font-bold text-[var(--rest-accent)]">
        <Sparkles className="w-3.5 h-3.5" /> ROI Kitxens
      </span>
      <b className="text-[13px] tabular-nums text-gray-900">+{money(d.extra_revenue)} {isEs ? 'este mes (est.)' : 'this month (est.)'}</b>
      <span className="text-[11.5px] text-gray-500 tabular-nums">
        {isEs ? 'con' : 'with'} {money(d.with_kitxens)} · {isEs ? 'sin' : 'without'} {money(d.without_kitxens)}
      </span>
      {d.uplift_pct != null && <span className="text-[11.5px] font-bold text-emerald-600 tabular-nums">▲ +{d.uplift_pct}%</span>}
      <span className="ml-auto text-[11px] font-bold text-gray-400">{isEs ? 'Ver detalle →' : 'See detail →'}</span>
    </Link>
  );
}
